import firebase from "firebase";
const firebaseConfig = {
  apiKey: "AIzaSyAqezlP7vTdAt7-gM_o2VtXc21Aah-lt7s",
  authDomain: "xinergy-832f0.firebaseapp.com",
  databaseURL: "https://xinergy-832f0.firebaseio.com",
  projectId: "xinergy-832f0",
  storageBucket: "xinergy-832f0.appspot.com",
  messagingSenderId: "489822442361",
  appId: "1:489822442361:web:c01d42da2cae1911c715a8",
  measurementId: "G-XFN576B8WL"
};

firebase.initializeApp(firebaseConfig);
export default firebase;